

export class ItemStorageChargeTypeEnum {
    
	static ReceivingFee: number = 10; 
	static MinimumReceivingFee: number = 11; 
	static PullForDelivery: number = 13; 
	static HandlingFee: number = 20; 
	static WillCallFee: number = 30; 
	static OversizeFee: number = 35; 
	static RepairFee: number = 40; 
	static SpecialStorageCharge: number = 50; 
	static WarehouseAssemblyFee: number = 60; 
	static UnstackableFee: number = 70; 
	static CratedOrPalletizedFee: number = 80; 
	static InspectionFee: number = 90; 
	static OrderFee: number = 100; 


	static getChoices(): any[] {
		return [
		{
			Value: ItemStorageChargeTypeEnum.ReceivingFee, Text: 'Receiving Fee'
	},{
			Value: ItemStorageChargeTypeEnum.MinimumReceivingFee, Text: 'Minimum Receiving Fee'
	},{
			Value: ItemStorageChargeTypeEnum.PullForDelivery, Text: 'Pull For Delivery'
	},{
			Value: ItemStorageChargeTypeEnum.HandlingFee, Text: 'Handling Fee'
	},{
			Value: ItemStorageChargeTypeEnum.WillCallFee, Text: 'Will Call Fee'
	},{
			Value: ItemStorageChargeTypeEnum.OversizeFee, Text: 'Oversize Fee'
	},{
			Value: ItemStorageChargeTypeEnum.RepairFee, Text: 'Repair Fee'
	},{
			Value: ItemStorageChargeTypeEnum.SpecialStorageCharge, Text: 'Special Storage Charge'
	},{
			Value: ItemStorageChargeTypeEnum.WarehouseAssemblyFee, Text: 'Warehouse Assembly Fee'
	},{
			Value: ItemStorageChargeTypeEnum.UnstackableFee, Text: 'Unstackable Fee'
	},{
			Value: ItemStorageChargeTypeEnum.CratedOrPalletizedFee, Text: 'Crated Or Palletized Fee'
	},{
			Value: ItemStorageChargeTypeEnum.InspectionFee, Text: 'Inspection Fee'
	},{
			Value: ItemStorageChargeTypeEnum.OrderFee, Text: 'Order Fee'
	}
			
		];
	}

}
